import ApiBlock from "components/API/ApiBlock";
import { ApiPageContextProvider } from "context/ApiPagecontext";

const ApiPage = () => {
  return (
    <ApiPageContextProvider>
      <ApiBlock />
    </ApiPageContextProvider>
  );
};

export default ApiPage;
